export enum EstatusTareaEnum {
    CREADO = 'CREADO',
    ACTIVO = 'ACTIVO',
    TERMINADO = 'TERMINADO',
    PAUSADO = 'PAUSADO',
    PENDIENTE = 'PENDIENTE'
}

export class EstatusTarea {
    public static obtenerEnum(valor: string): EstatusTareaEnum {
        switch (valor) {
            case 'CREADO': return EstatusTareaEnum.CREADO;
            case 'ACTIVO': return EstatusTareaEnum.ACTIVO;
            case 'TERMINADO': return EstatusTareaEnum.TERMINADO;
            case 'PAUSADO': return EstatusTareaEnum.PAUSADO;
            case 'PENDIENTE': return EstatusTareaEnum.PENDIENTE;
        }
        return null;
    }
}
